module.exports = __webpack_public_path__ + "static/media/Kingsley Shacklebolt 3.4982c7ba.jpg";